
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18.75","height":"30","viewBox":"0 0 18.75 30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.375 15A5.625 5.625 0 1115 9.375 5.633 5.633 0 019.375 15zm0-15A9.378 9.378 0 000 9.375C0 14.55 9.375 30 9.375 30S18.75 14.55 18.75 9.375A9.378 9.378 0 009.375 0z","fill":"#fff","fill-rule":"evenodd"}})])
          )
        }
      }
    